// eslint-disable-next-line import/no-extraneous-dependencies
import { Plugin } from '@nuxt/types';
import OrdersService from '~/services/OrdersService';

const ordersApiPlugin: Plugin = (_, inject) => {
  inject('ordersApi', OrdersService);
};

export default ordersApiPlugin;
